import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FiltroDealers } from './filtro-dealer';
import { FiltroTipoOs } from './filtro-tipo-os';
import { VeiculosSemPassagensFiltroService } from './veiculos-sem-passagens-filtro.service';
import { VeiculosSemPassagensService } from './veiculos-sem-passagens.service';

@Component({
  selector: 'app-veiculos-sem-passagens',
  templateUrl: './veiculos-sem-passagens.component.html',
  styleUrls: ['./veiculos-sem-passagens.component.scss']
})
export class VeiculosSemPassagensComponent implements OnInit {
  dataInicial: Date;
  dataFinal: Date;

  form: FormGroup;

  filtrosDealers: FiltroDealers;

  displayFiltrosDealers = false;
  displayFiltros = false;

  loading = false;
  cargaTela = false;

  dealersDados: any[] = [];
  rows: any[] = [];

  filtrosTipoOs: FiltroTipoOs;
  tipoOsSelecionados: any[] = [];
  displayModalTipos = false;
  filtroTipoTexto = '';

  cols: any[] = [];
  selectedColumns: any[] = [];

  constructor(
    private service: VeiculosSemPassagensService,
    private filtroService: VeiculosSemPassagensFiltroService,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    public translate: TranslateService,
  ) {
    this.filtrosDealers = new FiltroDealers(this.filtroService);
    this.filtrosTipoOs = new FiltroTipoOs(this.filtroService);
  }

  ngOnInit() {
    this.criarFormulario();
    this.criarColunas();
    this.definirDatasPadrao();
    this.filtrosDealers.carregar();
    this.filtrosTipoOs.carregar();

    
    this.rows = this.dealersDados;
  }

  private criarFormulario() {
    this.form = this.formBuilder.group({
      numeroChassi: ['']
    });
  }

 private criarColunas() {
    this.cols = [
      { field: 'numeroChassi', header: 'Chassi' },
      { field: 'modelo', header: 'Modelo' },
      { field: 'dataVenda', header: 'Data de Venda' },
      { field: 'possuiPlanoManutencao', header: 'Possui Plano de Manutenção' },
      { field: 'dealerUltimaPassagem', header: 'Dealer da Última Passagem' },
      { field: 'dataUltimaPassagem', header: 'Data da Última Passagem', sortField: 'dataUltimaPassagemOrdem' },
      { field: 'tipoOsFabrica', header: 'Tipo de O.S. Fábrica' },
      { field: 'numeroOs', header: 'Número da O.S' }
    ];
 
    this.selectedColumns = this.cols;
  }
  private definirDatasPadrao() {
    const hoje = new Date();
    this.dataInicial = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
    this.dataFinal = hoje;
  }

 filtroAPI() {
  if (!this.validarDatasPermitidas()) {
    return;
  }

  this.loading = true;
  this.cargaTela = true;
    const dataInicialFormatada = this.datePipe.transform(this.dataInicial, 'yyyy-MM-dd');
    const dataFinalFormatada = this.datePipe.transform(this.dataFinal, 'yyyy-MM-dd');
    const dealersSelecionados = this.getDealersSelecionados();
    const numeroChassi = this.form.get('numeroChassi').value || '';
    const tiposOsSelecionados = this.getTiposOsSelecionados();

    this.service.getDados(
      dataInicialFormatada,
      dataFinalFormatada,
      dealersSelecionados,
      numeroChassi,
      tiposOsSelecionados
    ).subscribe(
      response => {
        this.dealersDados = this.normalizarResponse(response);
        this.rows = this.dealersDados;
        this.loading = false;
        this.cargaTela = false;
        this.displayFiltros = false;
      },
      error => {
        this.dealersDados = [];
        this.rows = [];
        this.loading = false;
        this.cargaTela = false;
        this.toastr.error('Erro ao buscar relatório de veículos sem passagens.');
      }
    );
  }

  private normalizarResponse(response: any): any[] {
    if (!response) {
      return [];
    }

    if (Array.isArray(response)) {
      return response;
    }

    if (response.itens && Array.isArray(response.itens)) {
      return response.itens;
    }

    if (response.dados && Array.isArray(response.dados)) {
      return response.dados;
    }

    if (response.lista && Array.isArray(response.lista)) {
      return response.lista;
    }

    return [];
  }

  abrirModalTipos() {
    this.displayModalTipos = true;
  }

  tiposFiltrados(): any[] {
    const termo = (this.filtroTipoTexto || '').toLowerCase().trim();
    if (!termo) {
      return this.filtrosTipoOs.tipos;
    }
    return this.filtrosTipoOs.tipos.filter(t =>
      (t.nome && t.nome.toLowerCase().indexOf(termo) >= 0) ||
      (t.descricao && t.descricao.toLowerCase().indexOf(termo) >= 0)
    );
  }

  toggleTipo(tipo: any) {
    tipo.selecionado = !tipo.selecionado;
  }

  removerTipo(tipo: any) {
    tipo.selecionado = false;
  }

  getQtdTiposSelecionados(): number {
    return this.filtrosTipoOs.selecionados().length;
  }

  limparTipos() {
    this.filtrosTipoOs.tipos.forEach(t => t.selecionado = false);
  }

  confirmarTipos() {
    this.displayModalTipos = false;
  }

  private getTiposOsSelecionados(): string {
    const selecionados = this.filtrosTipoOs.selecionados();
    if (!selecionados || selecionados.length === 0) {
      return '';
    }
    return selecionados.map(t => t.id).join(',');
  }

  private getDealersSelecionados(): string {
    const selecionados = this.filtrosDealers.selecionados();

    if (!selecionados || selecionados.length === 0) {
      return '';
    }

    return selecionados.map(dealer => dealer.id).join(',');
  }

  selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
  }

  removerDealer(dealer: any) {
    dealer.selecionado = false;
  }

  exibirFiltro() {
    this.displayFiltros = true;
  }

  getListagemComFiltros(): boolean {
    const numeroChassi = this.form.get('numeroChassi').value;

    return numeroChassi !== null
      && numeroChassi !== undefined
      && numeroChassi.toString().trim() !== '';
  }

  limparFiltros() {
    this.form.reset({
      numeroChassi: ''
    });
  }

  limpaDataInicial() {
    this.dataInicial = null;
  }

  limpaDataFinal() {
    this.dataFinal = null;
  }

  abrirRmpvDetalhado(numeroChassi: string) {
    if (!numeroChassi) {
      return;
    }

    const dataInicialFormatada = this.datePipe.transform(this.dataInicial, 'yyyy-MM-dd');
    const dataFinalFormatada = this.datePipe.transform(this.dataFinal, 'yyyy-MM-dd');

    this.router.navigate(['/rmpv/detalhado'], {
      queryParams: {
        numeroChassi: numeroChassi,
        dataInicial: dataInicialFormatada,
        dataFinal: dataFinalFormatada
      }
    });
  }

  exportExcel() {
    if (!this.dealersDados || this.dealersDados.length === 0) {
      this.toastr.warning('Não existem dados para exportar.');
      return;
    }
    const header = this.selectedColumns.map(col => col.header).join(';');

    const linhas = this.dealersDados.map(item => {
      return this.selectedColumns
        .map(col => item[col.field] !== null && item[col.field] !== undefined ? item[col.field] : '')
        .join(';');
    });

    const conteudo = [header, ...linhas].join('\n');
    const blob = new Blob([conteudo], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'veiculos-sem-passagens.csv';
    link.click();
  }
  private validarDatasPermitidas(): boolean {
    if (!this.dataInicial || !this.dataFinal) {
      this.toastr.warning('Informe a data inicial e a data final.');
      return false;
    }

    if (this.dataInicial > this.dataFinal) {
      this.toastr.warning('A data inicial não pode ser maior que a data final.');
      return false;
    }

    return true;
  }
}